import { Directive, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';

@Directive({
  selector: '[appLongPress]',
  standalone: true,
})
export class LongPressDirective {
  @Output() longPress = new EventEmitter<void>();
  private readonly _el = inject(ElementRef);
  private _pressTimer?: any;

  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  startPress(event: Event): void {
    // event.preventDefault();
    this._pressTimer = setTimeout(() => {
      this.longPress.emit();
    }, 500);
  }

  @HostListener('mouseup')
  @HostListener('touchend')
  cancelPress(): void {
    clearTimeout(this._pressTimer);
  }

  @HostListener('mouseleave')
  cancelPressOnLeave(): void {
    clearTimeout(this._pressTimer);
  }
}
